import {
  Country,
  getCountryCallingCode,
  parsePhoneNumber,
  Value,
} from "react-phone-number-input";
import en from "react-phone-number-input/locale/en.json";
import { PhoneInputValue } from "./types";

export const getCountryFromValue = (
  value: Value | undefined,
  defaultCountry: Country
): Country => {
  if (!value) return defaultCountry;
  try {
    const parsed = parsePhoneNumber(value);
    return (parsed?.country as Country) ?? defaultCountry;
  } catch {
    return defaultCountry;
  }
};

export const getCountryName = (country: Country) => {
  return en[country];
};

export const parseToPhoneInputValue = (
  fullNumber: Value | undefined,
  country: Country
): PhoneInputValue | undefined => {
  if (!fullNumber) return undefined;

  const prefix = `+${getCountryCallingCode(country)}`;
  const number = fullNumber.startsWith(prefix)
    ? fullNumber.slice(prefix.length)
    : fullNumber.replace(/^\+\d+/, ""); // fallback: strip any dial code

  return { prefix, number };
};
